import { Subject } from "rxjs/Subject";
import * as i0 from "@angular/core";
var AggregationService = /** @class */ (function () {
    function AggregationService() {
        this.noGuaranteeIncome = false;
        //@Output() aggregationDone: EventEmitter<any> = new EventEmitter();
        //@Output() extAgg: EventEmitter<any> = new EventEmitter();
        this.aggregationDone = new Subject();
        this.aggComplete = false;
        this.contractcnt = 0;
        this.combData = [];
        this.contractError = false;
    }
    /**
     *
     * @param value
     */
    AggregationService.prototype.setContractError = function (value) {
        this.contractError = value;
    };
    AggregationService.prototype.emitAggDone = function () {
        this.aggComplete = true;
        this.aggregationDone.next("aggregationDone");
        try {
            window.dispatchEvent(new Event("allDone"));
        }
        catch (err) {
            var event = document.createEvent("Event");
            event.initEvent("allDone", true, true);
            document.dispatchEvent(event);
        }
    };
    /**
     *
     * @param combData
     * @param aggData
     */
    AggregationService.prototype.getAggAmt = function (combData, aggData) {
        var _this = this;
        this.contractcnt = combData.length;
        var agg = 0, aggKeys = [], aggVals = [];
        for (var k = 0; k < aggData.length; k++) {
            aggKeys[k] = aggData[k].container;
            aggVals[k] = 0;
        }
        if (!this.contractError) {
            var _loop_1 = function (l) {
                var _loop_2 = function (i) {
                    var targetContract = combData[i];
                    if (/success/i.test(targetContract.status)) {
                        if (!/(pending)/i.test(targetContract.contractStatus)) {
                            if (targetContract.primaryContractValue) {
                                if (/^amount/i.test(targetContract.primaryContractValue.valueType)) {
                                    var pContributesTo = targetContract.primaryContractValue.contributesTo;
                                    if (pContributesTo && pContributesTo.toString().toLowerCase() === aggKeys[l].toLowerCase()) {
                                        if (/income/i.test(pContributesTo) && /retirement/i.test(targetContract.lineOfBusiness)) {
                                            this_1.noGuaranteeIncome = true;
                                        }
                                        if (!isNaN(Number(targetContract.primaryContractValue.value))) {
                                            aggVals[l] += Number(targetContract.primaryContractValue.value);
                                        }
                                        else {
                                            this_1.contractError = true;
                                            return "break";
                                        }
                                    }
                                }
                                if ((!targetContract.primaryContractValue.value &&
                                    targetContract.primaryContractValue.valueType !== "HIDE") ||
                                    /^NOTAVAILABLE/i.test(targetContract.primaryContractValue.valueType)) {
                                    this_1.contractError = true;
                                    return "break";
                                }
                            }
                            else {
                                this_1.contractError = true;
                                return "break";
                            }
                            if (targetContract.secondaryContractValues) {
                                targetContract.secondaryContractValues.forEach(function (secondaryValue) {
                                    var group = secondaryValue.group;
                                    if (group) {
                                        group.forEach(function (item) {
                                            if (/^Amount/i.test(item.valueType)) {
                                                if (item.contributesTo &&
                                                    item.contributesTo.toString().toLowerCase() ===
                                                        aggKeys[l].toLowerCase()) {
                                                    if (/income/i.test(item.contributesTo) &&
                                                        /retirement/i.test(targetContract.lineOfBusiness)) {
                                                        _this.noGuaranteeIncome = true;
                                                    }
                                                    if (!isNaN(Number(item.value))) {
                                                        aggVals[l] = aggVals[l] + Number(item.value);
                                                    }
                                                    else {
                                                        _this.contractError = true;
                                                    }
                                                }
                                            }
                                            if (/NOTAVAILABLE/i.test(item.valueType)) {
                                                _this.contractError = true;
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    }
                    else {
                        if (!/(blocked|suppress)/i.test(targetContract.status)) {
                            this_1.contractError = true;
                        }
                    }
                };
                for (var i = 0; i < combData.length; i++) {
                    var state_1 = _loop_2(i);
                    if (state_1 === "break")
                        break;
                }
            };
            var this_1 = this;
            for (var l = 0; l < aggKeys.length; l++) {
                _loop_1(l);
            }
        }
        for (var m = 0; m < aggVals.length; m++) {
            if (this.contractError) {
                aggVals[m] = "0";
            }
            else {
                aggVals[m] = Number(aggVals[m]) === 0 ? "0" : aggVals[m];
            }
        }
        this.accountValues = aggVals;
        return aggVals;
    };
    AggregationService.ngInjectableDef = i0.defineInjectable({ factory: function AggregationService_Factory() { return new AggregationService(); }, token: AggregationService, providedIn: "root" });
    return AggregationService;
}());
export { AggregationService };
